import React, { useEffect, useState, useContext } from 'react'
import styles from '../../Css/CustomSettings.module.css'
import LoginScreen from './LoginScreen'
import { ContextConsumer, AuthContext } from '../../context/GlobalState'
import axios from 'axios'
import alertify from 'alertifyjs'

import posthog from 'posthog-js';
import { style } from '@mui/system'

// posthog.init("phc_p92egRlXhuEzPYkMaQVakJl0XCI82X507N84clTaJHH", {api_host: 'https://app.posthog.com'});
posthog.init("FoIzpWdbY_I9T_4jr5k4zzNuVJPcpzs_mIpO6y7581M", { api_host: 'https://app.posthog.com' });


function DownloadScreen(props) {

    const cookie = key => ((new RegExp((key || '=') + '=(.*?); ', 'gm')).exec(document.cookie + '; ') || ['', null])[1]

    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [activateButton, setActivateButton] = useState('Hd')
    const [authKey, setAuthKey] = useState(cookie('auth_token'));
    const [historyData, setHistoryData] = useState("");
    const [historyDataError, setHistoryDataError] = useState(false);
    const [imageUrls, setImageUrls] = useState([]);
    const [category, setCategory] = useState("");
    const [dummyImg, setDummyImg] = useState("");

    const context = useContext(AuthContext)
    
    useEffect(() => {
        let userEmail = cookie("emailId")
        let userId = cookie("userId")
        let category=""
        if (userId && userEmail && context.auth.loggedIn) {
            setIsLoggedIn(true)
        }
        const page_url=window.location.pathname
        // console.log(page_url)
        if(page_url.match("cars")) category="automobiles"
        if(page_url.match("fashion")) category="fashion"
        if(page_url.match("fabric")) category="fabric"
        if(page_url.match("food")) category="food"
        if(page_url.match("product")) category="product"
        if(page_url.match("footware")) category="footware"
        if(page_url.match("home-furnishing")) category="home-furnishing"
        setCategory(category)
        setDummyImg('https://storage.googleapis.com/spyne-website/cars-try/dummy.png')
    //    setAuth_key(cookie('auth_token'))
       fetchHistory(authKey,category)
        
    // console.log(history_data,"data")
    // console.log(category,"category")

    }, [])

    const fetchHistory = (authKey,category) => {
        
        axios({
            method : 'GET',
            url : process.env.REACT_APP_BASEURL+'/v2/fetch_history/cars',
            params: {
                auth_key: authKey,
                category : category
            }
        })
        .then((resp) => {
            if(resp.data.status==200){
                setHistoryData(resp.data.data)
            }
            else{
             setHistoryDataError(true)
            }
        })
    }

     if(historyData.length>2){
        historyData.map((e,i) => {
            imageUrls[i]= e.output_image_lres_url
        })
     }
     if(historyData.length==2){
        imageUrls[2]=dummyImg; 
        historyData.map((e,i) => {
            imageUrls[i]= e.output_image_lres_url
        })
     }
     if(historyData.length==1){
        imageUrls[2]= dummyImg; 
        imageUrls[1]=dummyImg;
        historyData.map((e,i) => {
            imageUrls[i]= e.output_image_lres_url
        })
     }
     if(historyData.length==0){
        imageUrls[2]=dummyImg; 
        imageUrls[1]= dummyImg;
        imageUrls[0]=props.fileList[0].fullResolutionOutput;
     }

    console.log(imageUrls)
    const handleActivateButton = (name) => {
        setActivateButton(name)
    }

    const downloadFunction = (response) => {
        let originalExt = response.url.split('.');
        originalExt = originalExt[originalExt.length - 1];
        response.arrayBuffer().then(function (buffer) {
            const url = window.URL.createObjectURL(new Blob([buffer]));
            const link = document.createElement("a");
            link.href = url;
            var filename = props.fileList[0].imageName
            if (filename.split('.').length < 2) {
                filename = filename + `.${originalExt}`
            }
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
        });
        props.getUserCredit();

    }
    const downloadImages = async () => {
        await axios({
            method: "GET",
            url: process.env.REACT_APP_BASEURL + "/v2/download/sku",
            params: {
                sku_id: props.fileList[0].skuId,
                auth_key: cookie("auth_token"),
            }
        })
            .then(resp => {
                const a = document.createElement("a")
                a.href = resp?.data?.data?.zip_file_url
                a.download = true
                a.click()
            });
        props.getUserCredit();

    }


    const handleDownloadImage = async () => {
        if (props.imgGenerationList.length > 0) {
            downloadImages()
            return
        }

        let userId = cookie('userId')
        let enterpriseId = cookie('enterpriseId')
        let price
        if (props.cropImageDetails && props.cropImageDetails[0] != props.fileList[0].thumbnailOutput) {
            await props.handleDownloadcropImg();
        }
        else {
            props.setCropImage(false)
        }
        if (activateButton === 'Hd') {
            price = props.bgCredit
            axios({
                method: "GET",
                url: process.env.REACT_APP_BASEURL + "/v4/download-history",
                params: {
                    user_id: userId,
                    enterprise_id: enterpriseId,
                    sku_id: props.fileList[0].skuId
                }

            }).then(resp => {
                if (resp.data.status === 404) {
                    let auth_key = cookie('auth_token')
                    const fd = new FormData()
                    fd.append("auth_key", auth_key)
                    fd.append("credit_reduce", 1)
                    fd.append("sku_id", props.fileList[0].skuId)
                    fd.append("image_id", props.fileList[0].imageId)
                    fd.append("source", 'SINGLEPROCESS')
                    axios.put(`${process.env.REACT_APP_BASEURL}/v2/credit/reduce-user-credit`, fd)
                        .then((res) => {

                            const output_link = activateButton === 'Hd' ? props.fileList[0].fullResolutionOutput : props.fileList[0].waterMarkImage;
                            fetch(output_link, {
                                method: "GET",
                                headers: {}
                            })
                                .then(response => {
                                    downloadFunction(response)

                                })

                            const fd = new FormData()
                            fd.append("user_id", userId)
                            fd.append("sku_id", props.fileList[0].skuId)
                            fd.append("enterprise_id", enterpriseId)
                            fd.append("download_hd", "true")
                            axios.post(`${process.env.REACT_APP_BASEURL}/v4/update-download-status`, fd)
                                .then(resp => {
                                    console.log(resp)
                                })

                        })
                } else {
                    const output_link = activateButton === 'Hd' ? props.fileList[0].fullResolutionOutput : props.fileList[0].waterMarkImage;
                    posthog.capture('Web HD Image Downloaded')
                    fetch(output_link, {
                        method: "GET",
                        headers: {}
                    })
                        .then(response => {
                            downloadFunction(response)

                        })
                }
            })
        } else {
            price = 0
            const output_link = activateButton === 'Hd' ? props.fileList[0].fullResolutionOutput : props.fileList[0].waterMarkImage;
            fetch(output_link, {
                method: "GET",
                headers: {}
            })
                .then(response => {
                    downloadFunction(response)

                })
        }
        alertify.success('Download Started, May take a while!');

    }

    const insertUsersImage = (auth_token) => {

        const fd = new FormData();

        fd.append("prod_cat_id", props.prodCatId);
        fd.append("output_image", props.fileList[0].fullResolutionOutput);
        fd.append("watermark_image", props.fileList[0].waterMarkImage);
        fd.append("display_image", props.fileList[0].thumbnailOutput);
        fd.append("input_image_url", props.fileList[0].url)
        fd.append("image_name", props.fileList[0].imageName)
        fd.append("bg_id", props.backgroundId)
        fd.append("auth_key", auth_token)
        fd.append('source', 'SINGLEPROCESS')
        fd.append('angle', props.angle)
        axios.post(`${process.env.REACT_APP_BASEURL}/v2/self-serve/enter-user-image`, fd)
            .then((resp) => {

                window.location.reload()
            })
    }

    return (
        <div>

            {isLoggedIn ?
                <>
                    <div className={[styles['right-content-area'], styles['download-right'], 'row m-0  download-page'].join(' ')}>

                        {/* <div className={[styles['solid-bg'],'col-md-11 col-lg-11'].join(' ')}>
                        <h6>Solid color <span>Backgrounds <i class="fa fa-info-circle" aria-hidden="true"></i> </span> <span className={styles['picker']}> Colour Picker <div className={[styles['color-picker']]}></div></span></h6>
                        <div className={[styles['solid-bg-image'],'row m-0'].join(' ')}>
                            <div className={[styles['solid-image'],styles['active'],'active'].join(' ')}>
                                <img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/transparent.png"/>
                                <p>Transparent</p>
                            </div>
                            <div className={[styles['solid-image'],''].join(' ')}>
                                <img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/gradient-1.png"/>
                                <p>Gradient 1</p>
                            </div>
                            <div className={[styles['solid-image'],''].join(' ')}>
                                <img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/transparent.png"/>
                                <p>Transparent</p>
                            </div>
                            <div className={[styles['solid-image'],''].join(' ')}>
                                <img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/gradient-1.png"/>
                                <p>Gradient 1</p>
                            </div>
                        </div> 
                    </div>
                <div className={[styles['solid-arrow'],'col-md-1 col-lg-1'].join(' ')}><i class="fa fa-chevron-right" aria-hidden="true"></i></div> */}

                        <div className={[styles['download-popup'], 'col-md-12'].join(' ')}>
                            <div className={[styles['download-screen-plans'], styles['screen-plan-web'], 'col-md-12'].join(' ')}>
                                <div className={styles['download-screen-plans-list-container']}>
                                    <ul className={styles['download-screen-plans-list']}>
                                        <li><h5>Credits</h5></li>
                                        <li><h1>Wallet Balance: {props.availableCredit}</h1></li>
                                        <li><a target="_blank" href="https://www.spyne.ai/tech/pricing">Purchase more Credits now <img src="https://storage.googleapis.com/spyne-website/static/images/Arrow%2022.png" /></a></li>
                                    </ul>
                                </div>
                                <div className={styles['download-screen-plans-image']}>
                                    <img src="https://storage.googleapis.com/spyne-website/static/images/coin-image.png" />
                                </div>
                            </div>

                            <button disabled={props.fileList[0].waterMarkImage ? false : true} className={activateButton === "Hd" ? [styles['download-hd'], styles['activate'], 'col-md-12 '].join(' ') : [styles['download-hd'], 'col-md-12 '].join(' ')} onClick={() => {
                                handleActivateButton("Hd")
                                handleDownloadImage()
                            }}>
                                <div className={styles['download-button-content']}>
                                    <div>
                                        <ul className={styles['download-button-content-list']}>
                                            <li><h6>HD Download</h6></li>
                                            <li className={styles['download-button-content-list-img-spec']}><span>Full Image 1920 × 1080 </span></li>
                                            <li>Without Watermark</li>
                                        </ul>
                                        <p>Price : <span>1 Credit/Image</span></p>
                                    </div>
                                    <div className={styles['download-button-image']}>
                                        <img src="https://storage.googleapis.com/spyne-website/download-button-gif.gif" />
                                    </div>
                                </div>
                            </button>

                            {/* For mobile view  */}
                            <div className={[styles['download-screen-plans'], styles['screen-plan-mob'], 'col-md-12'].join(' ')}>
                                <div className={styles['download-screen-plans-list-container']}>
                                    <ul className={styles['download-screen-plans-list']}>
                                        <li><h5>Credits</h5></li>
                                        <li><h1>Wallet Balance: {props.availableCredit}</h1></li>
                                        <li><a href="https://www.spyne.ai/tech/pricing">Purchase more Credits now <img src="https://storage.googleapis.com/spyne-website/static/images/Arrow%2022.png" /></a></li>
                                    </ul>
                                </div>
                                <div className={styles['download-screen-plans-image']}>
                                    <img src="https://storage.googleapis.com/spyne-website/static/images/coin-image.png" />
                                </div>
                            </div>
                            {/* End For mobile view  */}
                            {/* <div className={[styles['border-1'],''].join(' ')}></div> */}
                            {/* <div className="text-center">
                        <button onClick={handleDownloadImage}  className={[styles['download-btn-hd']]}>Download</button>
                    </div> */}
                        </div>
                    </div>
                    <div className={[styles['right-content-area'], styles['download-right'],styles['download-right-recent'], 'row  download-page'].join(' ')} >
                        <div className={[styles['download-popup'], 'col-md-12'].join(' ')} style={{marginTop:"12px",marginLeft:"7px",paddingRight:'3px'}}>
                            <div className={[styles['download-popup-recent'], 'col-md-12'].join(' ')} style={{padding:"0"}}>
                                <div className={[styles['download-popup-recent-top'], 'col-md-12','row'].join(' ')} style={{padding:"0"}}>
                                  <div className={[styles['recent-head'], 'col-md-6'].join(' ')} style={{paddingLeft:"3px"}}> Recent Images</div>
                                  <div className={[styles['my-dashboard'], 'col-md-6'].join(' ')} style={{textAlign:"right", paddingRight:"3px"}}> <a href="https://www.spyne.ai/dashboard/login"> My dashboard <span style={{marginLeft:"10px"}}> <img src="https://storage.googleapis.com/spyne-website/cars-try/ArrowRight.png" alt="" /> </span> </a> </div>
                                </div>
                                <div className={[styles['download-popup-recent-bottom'], 'col-md-12','row'].join(' ')} style={{padding:"0"}}>
                                
                                            <>
                                                {    
                                                imageUrls.map((e,i) => {
                                                return (
                                                    <div className={[styles['history-img'],'col-md-4'].join(' ')}>
                                                    { (category==="fashion" || category==="fabric") &&  imageUrls[i]!= dummyImg ?
                                                <img src={imageUrls[i]} className ={[styles['history-img-inner-potrait'],''].join(' ')} alt="" />
                                                :
                                                <img src={imageUrls[i]} className ={[styles['history-img-inner'],''].join(' ')} alt="" />}
                                                    </div>
                                                )
                                                })
                                                }   
                                            </>
                                            
                                </div>


                            </div>

                        </div>
                    </div>

                </>
                :
                <div className={[styles['right-content-area'], styles['login-right-area'], 'row m-0'].join(' ')}>
                    <LoginScreen
                        insertUsersImage={insertUsersImage}
                    />
                </div>
            }






        </div>
    )
}

export default DownloadScreen
